<template>
    <a-date-picker
        :get-calendar-container="getPopupContainer"
        placeholder="请选择年份"
        format="YYYY"
        mode="year"
        :value="year"
        :open="open"
        :allow-clear="false"
        @open-change="onOpenChange"
        @panel-change="onPanelChange"
        style="width: 100%"
        :disabled="disabled"
    />
</template>

<script>
import {ref, computed} from "vue";
import moment from "moment";
import {message} from "ant-design-vue";

export default {
    name: "YearPicker",
    emits: ["change", "update:value"],
    props: {
        value: {
            type: [String, Number],
        },
        start: {
            type: [String, Number],
            default: "",
        },
        end: {
            type: [String, Number],
            default: moment().format("YYYY"),
        },
        disabled:{
            type:Boolean,
            default: false
        }
    },
    setup(props, {emit}) {
        const year = computed(() =>
            props.value ? moment(props.value, "YYYY") : null
        );
        const open = ref(false);
        const onOpenChange = (status) => {
            open.value = !!status;
        };
        const onPanelChange = (value) => {
            if (parseInt(value.format("YYYY")) > parseInt(props.end)) {
                message.warning("当前年份无法选择");
                return false;
            }
            if (props.start && parseInt(value.format("YYYY")) < parseInt(props.start)) {
                message.warning("当前年份无法选择");
                return false;
            }
            let year = value.format("YYYY");
            setTimeout(() => {
            emit("change", year);
            }, 50);
            emit("update:value", year);
            open.value = false;
        };
        return {
            year,
            open,
            onOpenChange,
            onPanelChange,
        };
    },
};
</script>

<style scoped>
</style>
